import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Chip } from 'atoms/ui/Chip';
import { type SupportedCardSet, isSupportedCardSet } from 'lib/cardSets';
import { glossary } from 'lib/glossary';

import type { CardSetChip_cardSet } from './__generated__/index.graphql';

type Props = {
  cardSet: CardSetChip_cardSet;
};

const style: Record<SupportedCardSet, React.CSSProperties> = {
  'common-base-set': {},
  winter: {
    background: 'linear-gradient(315deg, #00a2f3 14.64%, #e8ecee 85.36%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
  },
};

export const CardSetChip = ({ cardSet }: Props) => {
  return (
    <Chip size="small" color="transparent">
      <span style={isSupportedCardSet(cardSet.slug) ? style[cardSet.slug] : {}}>
        <FormattedMessage
          {...glossary.setEdition}
          values={{
            set: cardSet.name,
          }}
        />
      </span>
    </Chip>
  );
};

CardSetChip.fragments = {
  cardSet: gql`
    fragment CardSetChip_cardSet on CardSet {
      slug
      name
    }
  ` as TypedDocumentNode<CardSetChip_cardSet>,
};
